export default "__VITE_ASSET__SWVFEZ5C__"